import React, { useState, useCallback } from 'react';
import { Input } from 'antd';
import { Search } from 'lucide-react';
import styles from '../index.module.css';
import _debounce from 'lodash/debounce';

type Props = {
  onSearch: (searchValue: string) => void;
  searchValue: string;
};

export const SearchTasks: React.FC<Props> = ({ onSearch, searchValue }) => {
  const [localSearchValue, setLocalSearchValue] = useState<string>(searchValue);
  const debouncedSearch = useCallback(_debounce(onSearch, 1500), []);

  return (
    <Input
      className={styles.searchInput}
      placeholder="Search tasks"
      defaultValue={searchValue}
      value={localSearchValue}
      onChange={e => {
        setLocalSearchValue(e.target.value);
        debouncedSearch(e.target.value);
      }}
      prefix={<Search size={16} />}
    />
  );
};
